import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalListComponent } from '../../shared/global-list';

@Component({
  selector: 'app-unauthorized',
  imports: [TranslateModule],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss'
})
export class UnauthorizedComponent extends GlobalListComponent {
  goHome() {
    // '/main/dashboard' doesn't exist; Records is open to every role
    this.router.navigate(['/main/records']);
  }
}
